import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Pagination } from '../../shared/pagination.model';
import { BaseApiTemplateService } from '../../shared/base-api-template-service.model';
import { StockTakeSessionHeaderModel } from '../../../../../../models/aggregates/erp/stock';
import { ApiResponseModel, BasicApiResponseModel, PagingResponseModel } from '../../shared/api-response.model';
import { Core2Config } from '../../shared/core2Config';
import { ApiVisa } from '../../shared/api-visa.model';
import { Observable } from 'rxjs';
import { StockTakeSessionHdrCriteriaModelQuery, StockTakeSessionHdrQueryCriteriaClass } from '../../../criteria/stock';

@Injectable({ providedIn: 'root' })
export class StockTakeHdrService extends BaseApiTemplateService<StockTakeSessionHeaderModel> {
  readonly url = Core2Config.DOMAIN_URL + Core2Config.DOMAIN_URL_PREFIX + 'stocktake-hdr';

  constructor(theHttp: HttpClient) {
    super();
    this.apiUrl = Core2Config.DOMAIN_URL + Core2Config.DOMAIN_URL_PREFIX + 'stocktake-hdr';
    this.endpoint_path = Core2Config.DOMAIN_URL_PREFIX + 'stocktake-hdr';

    this.httpClient = theHttp;
  }

  getStockTakeHdrByCriteria(visa: ApiVisa, criteria?: StockTakeSessionHdrQueryCriteriaClass):
    Observable<PagingResponseModel<any>> {
    if (this.endpoint_path && visa.api_domain_url) {
      this.apiUrl = visa.api_domain_url + this.endpoint_path;
    }
    const buildStockTakeDeviceCriteria = new StockTakeSessionHdrCriteriaModelQuery(criteria);
    // console.log('stockDevice: ', this.apiUrl + '/query?' + buildStockTakeDeviceCriteria.query);
    return this.httpClient.get<PagingResponseModel<any>>(this.apiUrl + '/query?' + buildStockTakeDeviceCriteria.query, this.getHttpHeader(visa));
  }

  updatetStocktakeHdr(visa: ApiVisa, session: StockTakeSessionHeaderModel, appletGuid: string):
    Observable<BasicApiResponseModel<StockTakeSessionHeaderModel>> {
    if (this.endpoint_path && visa.api_domain_url) {
      this.apiUrl = visa.api_domain_url + this.endpoint_path;
    }
    return this.httpClient.put<BasicApiResponseModel<StockTakeSessionHeaderModel>>(this.apiUrl +
      '?app-hdr-guid=' + appletGuid, session, this.getHttpHeader(visa));
  }
}
